import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';
import { IFullState } from '../types/All.type';
import { rolePermissions, MESSAGE } from '../constants/Permission';
import Unauthorized from '../components/Auth/UnAuthorized';

const SummaryReportsCom = React.lazy(
  () => import('../components/SummaryReports')
);

function SummaryReports(): ReactElement {
  const { permissions } = useSelector(
    (state: IFullState) => state.genesisUserRolePermission
  );
  return (
    <SuspenseLoadPage>
      {permissions.includes(rolePermissions.listMasterData) ? (
        <SummaryReportsCom />
      ) : (
        <Unauthorized message={MESSAGE.unAuthorized} backOption />
      )}
    </SuspenseLoadPage>
  );
}

export default SummaryReports;
